import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_REVIEWS = '' } =
    useRuntimeConfig().public

  const areReviewsFrontAppsRoutesOpenedInCountry = (
    FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_REVIEWS as string
  ).includes(market.countryCode)

  return [
    {
      name: ROUTES.FORM,
      path: '/:locale/review/:id',
      component: () => null,
      meta: {
        disableClientSideNavigation: () => true,
      },
    },
    {
      name: ROUTES.PAGES.LANDING,
      path: '/:locale/r/l/:slugV2/:uuid',
      component: () => import('./pages/Reviews.vue'),
      meta: {
        disableClientSideNavigation: () =>
          !areReviewsFrontAppsRoutesOpenedInCountry,
      },
    },
    {
      name: ROUTES.PAGES.MERCHANT,
      path: '/:locale/r/s/:merchantName/:uuid',
      component: () => import('./pages/Reviews.vue'),
      meta: {
        disableClientSideNavigation: () =>
          !areReviewsFrontAppsRoutesOpenedInCountry,
      },
    },
    {
      name: ROUTES.PAGES.PRODUCT,
      path: '/:locale/r/p/:slugV2/:uuid',
      component: () => import('./pages/Reviews.vue'),
      meta: {
        disableClientSideNavigation: () =>
          !areReviewsFrontAppsRoutesOpenedInCountry,
      },
    },
    // Matching Pastrami route
    {
      name: ROUTES.PAGES.LEGACY_PRODUCT,
      path: '/:locale/r/p/:uuid',
      component: () => null,
      meta: {
        disableClientSideNavigation: () => true,
      },
    },
    {
      name: ROUTES.PAGES.ALL,
      path: '/:locale/r',
      component: () => import('./pages/Reviews.vue'),
      meta: {
        disableClientSideNavigation: () =>
          !areReviewsFrontAppsRoutesOpenedInCountry,
      },
    },
  ]
}
